import * as RouterDOM from 'react-router-dom'

import { ElementPlugin } from '../Element/plugin'
import { AppDefinition } from './TypedDefinition'
import { AppNode } from './TypedNode'
import { AppComponent } from './ViewComponent'
import { AppModel } from './ViewModel'

import type { PluginLike, PluginVisitors, RehajePlugin } from '@rehaje/core'
import type { ReactElement } from 'react'

export interface AppPluginProps {
  /**
   * React Router 基础路径
   */
  basename?: string
  /**
   * 错误显示组件
   */
  errorElement?: ReactElement
  /**
   * 加载组件
   */
  spinnerElement?: ReactElement
}

export class AppPlugin implements RehajePlugin {
  plugins: PluginLike[] = [
    new ElementPlugin({
      components: {
        Outlet: RouterDOM.Outlet
      }
    })
  ]

  props: AppPluginProps

  visitors: PluginVisitors

  constructor(props?: AppPluginProps) {
    this.props = { ...props }
    this.visitors = {
      components: {
        App: AppComponent
      },
      definitions: {
        App: AppDefinition
      },
      models: {
        App: AppModel
      },
      nodes: {
        App: AppNode
      }
    }
  }
}
